/* ============
 * Actions for the assessment module
 * ============
 *
 * The actions that are available on the
 * assessment module.
 */
// import Vue from 'vue';
import OrganisationProxy from '@/proxies/OrganisationProxy';
import types from './mutation-types';


export const getOrganisations = ({
  commit
}, data) => {
  commit(types.FETCH_ORGANISATIONS);
  new OrganisationProxy().getOrganisations(data)
  .then((response) => {
    commit(types.FETCH_ORGANISATIONS_SUCCESS, response);
  }).catch((error) => {
    commit(types.FETCH_ORGANISATIONS_FAIL, error);
  });
};

export default {
  getOrganisations
};
